import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import Experience from './Experience.js'

export default class Camera
{
    constructor()
    {
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas

        this.setInstance()
        this.setControls()
    }

    setInstance()
    {
        this.instance = new THREE.PerspectiveCamera(
            15,
            this.sizes.width / this.sizes.height,
            0.1,
            100
        )
        this.instance.position.set(1, 1.6, 1.6)
        this.scene.add(this.instance)
    }

    setControls()
    {
        this.constrols = new OrbitControls(this.instance, this.canvas)
        this.constrols.enableDamping = true
    }

    resize()
    {
        this.instance.aspect = this.sizes.width / this.sizes.height
        this.instance.updateProjectionMatrix()
    }

    update()
    {
        this.constrols.update()
    }
}